import { RootContext } from "@/contexts/RootContext";
import { useContext } from "react";

export function useRootContext() {
  return useContext(RootContext);
}
